import CouponApi from '@apis/coupon/CouponApi';
import queries from '@apis/queries';
import { GetCouponsParams } from '@models/coupon';
import { useInfiniteQuery } from '@tanstack/react-query';
import { getFlattenPageResponse, getIsBlank, getNextPageParam } from '@utils/slice';
import { useState } from 'react';

function useMyCoupons() {
    const [sort, setSort] = useState<'IssuedAtDesc' | 'ExpiresAtAsc'>('IssuedAtDesc');
    const params: Omit<GetCouponsParams, 'page'> = {
        size: 10,
        sorter: sort,
    };
    const queryInfo = useInfiniteQuery({
        queryKey: queries.coupons.list(params).queryKey,
        queryFn: ({ pageParam }) => CouponApi.getMyCoupons({
            ...params,
            page: pageParam,
        }),
        initialPageParam: 0,
        refetchOnMount: 'always',
        staleTime: 0,
        getNextPageParam,
    });
    const coupons = getFlattenPageResponse(queryInfo);
    const isEmpty = getIsBlank(queryInfo);
    return {
        ...queryInfo,
        coupons,
        isEmpty,
        sort,
        setSort,
    };
}

export default useMyCoupons;
